import { all, takeLatest, put, select } from 'redux-saga/effects';
import { matchesType } from '../sagas';
import * as actions from '../../Actions/emailExample';
import { sendTestInvitation } from '../../Api/invitationSettingsClient';
import { EmailSentFrom } from '../../Model';

function* sendEmail(event: any) {
  const { data, sentFrom } = event.payload;
  const { account } = yield select((state) => state.App);
  yield sendTestInvitation(account.businessUnitId, data);

  yield put(actions.emailSent({
    ...sentFrom === EmailSentFrom.PastOrders && { testInvitationSentPastOrders: true },
    ...sentFrom === EmailSentFrom.ProductReviews && { testInvitationSentProductReviews: true },
  }));
}

function* emailExample() {
  yield all([takeLatest(matchesType(actions.sendEmail), sendEmail)]);
}

export { emailExample };



// WEBPACK FOOTER //
// ./src/redux/sagas/emailExample.ts